import CryptoJS from "crypto-js";

function decryptResponse(data) {

  try {
    if (process.env.REACT_APP_STAGING === "true") {
      const bytes = CryptoJS.AES.decrypt(
        data,
        process.env.REACT_APP_SECRET_KEY
      );
      const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptData;
    } else {
      return data;
    }
  } catch (error) {
    console.error("Decryption error:", error);
    return null; // or handle the error in an appropriate way
  }
}
export default decryptResponse;
